enum UserTypesEnum {
  NEW = 'nuevo',
  RECURRING = 'recurrente',
  QUALIFIED = 'cualificado',
  INSURED = 'asegurado'
}

export default UserTypesEnum
